import * as core from '@theatre/core'
import studio from '@theatre/studio'

// @ts-ignore
window.Theatre = {
  core,
  studio,
}
